"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericModalCTA = exports.FeedHandlerType = void 0;
var FeedHandlerType;
(function (FeedHandlerType) {
    FeedHandlerType["viewProfile"] = "viewProfile";
    FeedHandlerType["genericModal"] = "genericModal";
    FeedHandlerType["viewFeatureCarousel"] = "viewFeatureCarousel";
    FeedHandlerType["viewPeerEndorsements"] = "viewPeerEndorsements";
    FeedHandlerType["viewPersonalInsight"] = "viewPersonalInsight";
    FeedHandlerType["viewEndorsementDigest"] = "viewEndorsementDigest";
    FeedHandlerType["viewTraitRatingModal"] = "viewTraitRatingModal";
    FeedHandlerType["viewExternalLink"] = "viewExternalLink";
    FeedHandlerType["viewPremiumConversionModal"] = "viewPremiumConversionModal";
    FeedHandlerType["viewCommentThread"] = "viewCommentThread";
    FeedHandlerType["viewRewards"] = "viewRewards";
    FeedHandlerType["viewStory"] = "viewStory";
    FeedHandlerType["viewSimilarity"] = "viewSimilarity";
    FeedHandlerType["viewCompatibility"] = "viewCompatibility";
    FeedHandlerType["viewCompatibilitySnippet"] = "viewCompatibilitySnippet";
    FeedHandlerType["viewArchetype"] = "viewArchetype";
    FeedHandlerType["viewNatureBreakdown"] = "viewNatureBreakdown";
    FeedHandlerType["viewPeerAssessment"] = "viewPeerAssessment";
    FeedHandlerType["viewPeerFeedbackLevelsModal"] = "viewPeerFeedbackLevelsModal";
    FeedHandlerType["viewPeriodicQuiz"] = "viewPeriodicQuiz";
    FeedHandlerType["viewResultSnippet"] = "viewResultSnippet";
    FeedHandlerType["viewSharedPost"] = "viewSharedPost";
    FeedHandlerType["viewPeerStory"] = "viewPeerStory";
})(FeedHandlerType = exports.FeedHandlerType || (exports.FeedHandlerType = {}));
var GenericModalCTA;
(function (GenericModalCTA) {
    GenericModalCTA["viewPublicProfile"] = "viewPublicProfile";
})(GenericModalCTA = exports.GenericModalCTA || (exports.GenericModalCTA = {}));
